export default function ContactSection() {
  return (
    <section id="contact" className="w-full bg-background-50">
      <div className="flex flex-col lg:flex-row min-h-[500px]">
        <div className="lg:w-1/2 relative bg-background-100 flex items-end min-h-[320px] lg:min-h-[560px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=dramatic%20warm%20toned%20abstract%20art%20with%20crimson%20and%20dark%20amber%20gradients%2C%20soft%20ethereal%20glow%2C%20mysterious%20editorial%20aesthetic%2C%20fine%20art%20photography%20style%2C%20no%20text%2C%20no%20people%2C%20dark%20elegant%20mood&width=900&height=1100&seq=contact-visual-51cg-003&orientation=portrait"
            alt="投稿爆料视觉"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-transparent"></div>
          <div className="relative z-10 p-8 md:p-12 lg:p-16 w-full">
            <span className="text-white/60 text-xs md:text-sm font-medium tracking-widest uppercase mb-3 block">CONTACT</span>
            <h2 className="text-white font-heading font-bold text-3xl md:text-4xl lg:text-5xl leading-tight">
              有料就爆
              <br />
              一起吃瓜
              <br />
              全网最快
            </h2>
          </div>
        </div>

        <div className="lg:w-1/2 bg-background-50 flex flex-col items-center justify-center px-6 md:px-12 py-12 lg:py-0">
          <h2 className="text-foreground-950 font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-center leading-tight mb-2">
            联系我们
          </h2>
          <h3 className="text-foreground-950 font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-center leading-tight mb-5">
            投稿 · 爆料 · 咨询
          </h3>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed text-center max-w-md mb-6">
            您有独家爆料线索？想联系我们进行商务合作或内容咨询？欢迎通过以下方式与我们取得联系。所有投稿均采用匿名处理，严格保护爆料人隐私，重大独家爆料一经采用还可获得平台奖励。
          </p>
          <a
            href="#contact-form"
            className="inline-flex items-center gap-2 bg-secondary-600 hover:bg-secondary-700 text-white px-6 py-3 rounded-full text-sm md:text-base font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            进入投稿通道
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}